// extracted by mini-css-extract-plugin
export var hero = "forbidden-403-module--hero--Hxc4U";
export var wrapper = "forbidden-403-module--wrapper--Fb+ir";